<template>
  <div class="auth-nav">
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand to="/">{{$t('appName')}}</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            to="/"
            exact-active-class="active">
            {{$t('authedNav.jobs')}}
          </b-nav-item>
          <b-nav-item
            to="/create-job"
            exact-active-class="active">
            {{$t('authedNav.createJob')}}
          </b-nav-item>
          <b-nav-item
            to="/keywords"
            exact-active-class="active">
            {{$t('authedNav.keywords')}}
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <span class="fa fa-user-circle"></span>
              {{user.firstName}} {{user.lastName}}
            </template>
            <b-dropdown-item to="/my-account">{{$t('authedNav.myAccount')}}</b-dropdown-item>
            <b-dropdown-item @click="logout">{{$t('authedNav.signOut')}}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: mapState({
      user: state => state.account.user,
    }),
    methods: {
      logout() {
        this.$store.dispatch('account/logout');
      },
    },
  };
</script>
